const translateProps: Record<any, any> = {
  description: 'Descrição',
  blockchainTransactionId: 'Id da Transação Blockchain',
  origin: 'Origem',
}

export const translateObject = (obj: any, link?: string, authInfo?: any) => {
  const translatedObj = {} as any
  for (const prop in obj) {
    if (obj[prop] && typeof obj[prop] === 'object') {
      translatedObj[translateProps[prop] || prop] = translateObject(
        obj[prop],
        link,
        authInfo,
      )
    } else {
      if (prop === 'blockchainTransactionId') {
        translatedObj['Id da Transação Blockchain'] = {
          description: obj[prop] ?? '',
          href: `${link ?? ''}?tab=transactions&transId=${obj[prop]}&authInfo=${authInfo}`,
        }
      } else {
        translatedObj[translateProps[prop] || prop] = obj[prop]
      }
    }
  }
  return translatedObj
}
